import * as React from 'react';
import getStore from '../store/store';
import RequestStatus from '../store/schema/RequestStatus';
import strings from 'owa-strings/owa-options-strings';
import TimeZone from './TimeZone';
import Weather from './Weather';
import { addToAgendaMailDisabledMap, setAgendaMailEnabled } from '../actions/internalActions';
import { initializeAgendaMailOption } from '../actions/publicActions';
import { observer } from 'mobx-react';
import { OptionDescription, OptionsCheckbox } from 'owa-options-controls';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { Toggle } from 'office-ui-fabric-react/lib';

const styles = require('./AgendaMailFull.scss');

@observer
export default class AgendaMailFull extends React.Component<{}, {}> {
    componentDidMount() {
        // Try fetch calendar folders if the getCalendarFolder request has error, or it hasn't been issued yet, or the previous call succeeds, i.e
        // status is either NotInitialized, Error or Completed. This is to keep the calendar folders up-to-date
        // every time user switches between option tabs until fixing https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/38659
        const requestStatus = getStore().getCalendarFoldersServiceStatus;
        if (
            requestStatus === RequestStatus.NotInitialized ||
            requestStatus === RequestStatus.Error ||
            requestStatus === RequestStatus.Completed
        ) {
            initializeAgendaMailOption();
        }
    }

    render() {
        const isAgendaMailEnabledForUser = getStore().isAgendaMailEnabled;
        return (
            <>
                <OptionDescription>{strings.options_agenda_EmailDescription}</OptionDescription>
                <Toggle
                    key={'agendaMailEnabled'}
                    onText={strings.options_agenda_Email_OptionLabel}
                    offText={strings.options_agenda_Email_OptionLabel}
                    checked={isAgendaMailEnabledForUser}
                    onChange={(ev, checked) => setAgendaMailEnabled(checked)}
                />
                {this.renderCalendarFoldersSection()}
                <TimeZone />
                <Weather />
            </>
        );
    }

    private renderCalendarFoldersSection = (): JSX.Element => {
        if (getStore().serverCalendarFolders.length > 0) {
            // If local store contains the calendar folders, render them immediately. This could happen
            // when user switches to agenda mail option multiple times, and client shows local data immediately while
            // the GetCalendarFolders call is pending
            return this.renderFolderEntries();
        }

        const getFoldersRequestStatus = getStore().getCalendarFoldersServiceStatus;

        switch (getFoldersRequestStatus) {
            case RequestStatus.Pending:
                return <Spinner />;

            case RequestStatus.Error:
                return <p>Something went wrong. Please try again.</p>;

            case RequestStatus.Completed:
            case RequestStatus.NotInitialized:
                return this.renderFolderEntries();

            default:
                return null;
        }
    };

    private renderFolderEntries = (): JSX.Element => {
        const calendarFolders = getStore().serverCalendarFolders;
        if (calendarFolders.length === 0) {
            return null;
        }

        const isAgendaMailEnabledForUser = getStore().isAgendaMailEnabled;
        const agendaMailDisabledMap = getStore().agendaMailDisabledMap;

        const calendarFolderEntriesToRender = calendarFolders.map(folder => (
            <OptionsCheckbox
                key={folder.FolderId.Id}
                label={folder.DisplayName}
                checked={!agendaMailDisabledMap.get(folder.FolderId.Id)}
                disabled={!isAgendaMailEnabledForUser}
                onChange={(ev, checked) => addToAgendaMailDisabledMap(folder.FolderId.Id, !checked)}
            />
        ));

        return (
            <div className={styles.calendarFolderContainer}>
                <p>{strings.options_agenda_Email_Calendar_ListTitle}</p>
                {calendarFolderEntriesToRender}
            </div>
        );
    };
}
